import type { FC, PropsWithChildren } from 'react'
import { useState } from 'react'
import styled from '@emotion/styled'

import VideoPlayerBase, * as VideoPlayer from '@segment/matcha/components/VideoPlayer'

import CoverImage from './CoverImage'

export interface VideoProps {
  url: string
}

const Video: FC<PropsWithChildren<VideoProps>> = ({ url }) => {
  const [playing, setPlaying] = useState(false)
  const play = () => setPlaying(true)
  const stop = () => setPlaying(false)

  return (
    <Wrapper>
      <VideoPlayerBase url={url} playing={playing} onPause={stop} onPlay={play}>
        {!playing && <VideoPlayer.BigPlayButton ariaLabel="Play Button" onClick={play} />}
        {!playing && <CoverImage key="cover" />}
      </VideoPlayerBase>
    </Wrapper>
  )
}

export default Video

const Wrapper = styled.div`
  margin-bottom: 30px;

  ${({ theme }) => theme.breakpoints.up(`md`)} {
    margin-bottom: 60px;
  }
`
